// src/features/mensagens/components/chat/DateSeparator.jsx
// ============================================================================
// 📅 DATESEPARATOR — Separador de Fecha en el Chat
// 📦 V1 ENTERPRISE — Agrupación Visual · Estilo WhatsApp
// ============================================================================

import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { formatDateLabel } from '../../utils/formatters';

const DateSeparator = memo(({ date, label }) => {
  const displayLabel = label || (date ? formatDateLabel(date) : null);

  if (!displayLabel) return null;

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.2 }}
      className="flex items-center justify-center py-3 px-4 select-none"
    >
      <div className="bg-white/80 backdrop-blur-sm rounded-full px-3.5 py-1 shadow-sm border border-gray-200/50">
        <span className="text-xs font-medium text-gray-500">
          {displayLabel}
        </span>
      </div>
    </motion.div>
  );
});

DateSeparator.displayName = 'DateSeparator';
export { DateSeparator };
export default DateSeparator;